import appRoutes from "../../../../routes/appRoutes";

export const superAdminMenuItems = [
  {
    label: "Support Chat",
    value: appRoutes.supportChat,
    icon: "fa fa-comment"
  },
  {
    label: "Forum",
    value: appRoutes.viewForum,
    icon: "fa fa-comments"
  },
  {
    label: "Action Invalid IHI",
    value: appRoutes.traditionalPrescriptionList,
    icon: "fas fa-file-prescription"
  },
  {
    label: "Tickets",
    value: "Tickets",
    icon: "fa fa-ticket-alt",
    children: [
      { label: "View Tickets", value: appRoutes.viewTickets },
      { label: "Generate Ticket", value: appRoutes.generateTicket },
      { label: "Received Results", value: appRoutes.receivedResults }
    ]
  },
  // {
  //   label: "Bookings",
  //   value: "Bookings",
  //   icon: "fa fa-calendar-check",
  //   children: [
  //     { label: "View Bookings", value: appRoutes.viewBookings },
  //     {
  //       label: "Generate Booking",
  //       value: appRoutes.generateBooking
  //     }
  //   ]
  // },

  {
    label: "Patients",
    value: "Patients",
    icon: "fa fa-users",
    children: [
      {
        label: "Patients In Queue",
        value: appRoutes.patientsInQueue
      },
      { label: "Consult Requests", value: appRoutes.consultRequests },
      { label: "Patients", value: appRoutes.patients }
      // { label: "Bookings", value: appRoutes.bookings }
    ]
  },
  {
    label: "Doctors",
    value: "Doctors",
    icon: "fa fa-user-md",
    children: [
      { label: "Doctors In Queue", value: appRoutes.doctorsInQueue },
      {
        label: "New Applications",
        value: appRoutes.doctorNewApplications
      },
      { label: "Approved", value: appRoutes.doctorApproved },
      { label: "Rejected", value: appRoutes.doctorRejected }
    ]
  },
  // {
  //   label: "Nurses",
  //   value: "Nurses",
  //   icon: "fa fa-heartbeat",
  //   children: [
  //     { label: "Nurses In Queue", value: appRoutes.nursesInQueue },
  //     {
  //       label: "New Applications",
  //       value: appRoutes.nurseNewApplications
  //     },
  //     { label: "Approved", value: appRoutes.nurseApproved },
  //     { label: "Rejected", value: appRoutes.nurseRejected }
  //   ]
  // },
  {
    label: "Pharmacies",
    value: appRoutes.pharmacies,
    icon: "fa fa-medkit"
  },
  {
    label: "Drug Database Settings",
    value: "Drug Database Settings",
    icon: "fa fa-pills",
    children: [
      { label: "Drug Database", value: appRoutes.drugDatabase },
      { label: "Blocked Drugs", value: appRoutes.blockedDrugs }
    ]
  },
  {
    label: "Nature of Consult",
    value: appRoutes.natureOfConsult,
    icon: "fa fa-bars"
  },
  {
    label: "Consult Costs",
    value: "Consult Costs",
    icon: "fa fa-dollar-sign",
    children: [
      {
        label: "Private Fee",
        value: "Private Fee",
        icon: "",
        children: [
          {
            label: "Instant Consult",
            value: appRoutes.consultCosts
          },
          {
            label: "Instant Switch",
            value: appRoutes.consultCostsInstantSwitch
          }, {
            label: "Instant Leaf",
            value: appRoutes.consultCostsMedicinalCannabis
          },
          {
            label: "Instant Hush",
            value: appRoutes.consultCostsInstantHush
          }
        ]
      },
      {
        label: "MBS",
        value: "MBS",
        children: [
          {
            label: "Instant Consult",
            value: appRoutes.consultCostsMedicare
          }
          // {
          //   label: "Instant Switch",
          //   value: appRoutes.instantSwitchConsultCostMedicare
          // }
        ]
      },
      { label: "Coupons", value: appRoutes.viewCouponsList }
    ]
  },
  // {
  //   label: "Consult Costs",
  //   value: "Consult Costs",
  //   icon: "fa fa-dollar-sign",
  //   children: [
  //     { label: "Coupons", value: appRoutes.viewCouponsList },
  //     { label: "Private Fee", value: appRoutes.consultCosts },
  //     {
  //       label: "MBS",
  //       value: appRoutes.consultCostsMedicare
  //     }, {
  //       label: "Private Fee Instant Switch",
  //       value: appRoutes.consultCostsInstantSwitch
  //     },
  //     {
  //       label: "MBS Instant Switch ",
  //       value: appRoutes.instantSwitchConsultCostMedicare
  //     },
  //     {
  //       label: "Private Fee Instant Hush",
  //       value: appRoutes.consultCostsInstantHush
  //     }
  //   ]
  // },
  {
    label: "Consult History",
    value: "Consult History",
    icon: "fa fa-history",
    children: [
      { label: "Past Consults", value: appRoutes.pastConsults },
      {
        label: "Unanswered Consults",
        value: appRoutes.unansweredConsultRequests
      },
      {
        label: "Consult Counts",
        value: appRoutes.appointmentCounts
      }
    ]
  }, {
    label: "Instant Extras",
    value: "Instant Extras",
    icon: "fas fa-plus-square",
    children: [
      {
        label: "Scheduling",
        value: appRoutes.instantExtraDoctorSchedule
      }, {
        label: "Assessments",
        value: appRoutes.instantExtraAssessments
      }
    ]
  }, {
    label: "Instant Switch",
    value: appRoutes.instantSwitchOnlineAssessments,
    icon: "fa fa-smoking-ban"
  }, {
    label: "Instant Leaf",
    value: appRoutes.medicinalCannabisOnlineAssessments,
    icon: "fas fa-cannabis"
  },
  {
    label: "Instant Hush",
    value: appRoutes.instantHushOnlineAssessments,
    icon: "fas fa-mars"
  },
  {
    label: "Marketing",
    value: appRoutes.marketing,
    icon: "fa fa-bullhorn"
  },
  { label: "FAQs", value: appRoutes.faqs, icon: "fa fa-question" },
  { label: "Legal", value: appRoutes.viewLegal, icon: "fa fa-file" },
  {
    label: "Logins",
    value: appRoutes.loginsSupportStaff,
    icon: "fa fa-key"
  },
  {
    label: "Settings",
    value: appRoutes.appSettings,
    icon: "fa fa-cog"
  }
  // {
  //   label: "Log File",
  //   value: appRoutes.logFile,
  //   icon: "fa fa-file-excel"
  // },
  // {
  //   label: "Security Setting",
  //   value: appRoutes.securitySetting,
  //   icon: "fas fa-key"
  // }
];